/* @flow */
import Image from 'components/Image.jsx';
import React from 'react';

import cx from 'classnames';
import { imgSrcForUnicodeEmoji } from 'lib/emoji';

import styles from './styles/Emoji.css';


/**
 * Displays a Unicode emoji character using [twemoji](http://twitter.github.io/twemoji/).
 *
 * ```example
 *  <div>
 *    <Emoji character="\ud83c\udfc3" />
 *    <Emoji character="\ud83d\udca8 " />
 *    <Emoji character="\ud83d\ude93" />
 *    <Emoji character="\ud83d\ude93" />
 *    <Emoji character="\ud83d\ude93" />
 *  </div>
 * ```
 *
 * You will rarely use this component directly. Rather, look at `TextWithEntities` and
 * `TextEntities` to parse and convert Emoji for cross-platform support.
 *
 * ```js
 *  <TextWithEntities
 *    text={text}
 *    entities={
 *      [].concat(
 *        TextEntities.parseEmoji(text),
 *        TextEntities.parseUrls(text)
 *      )
 *    }
 *  />
 * ```
 *
 */

const Emoji = ({ character, className }: {character: string, className?: ?string}) => (
  <Image
    className={cx(styles.this, className)}
    disableUserInteraction
    src={imgSrcForUnicodeEmoji(character)}
    alt={character}
  />
);

export default Emoji;



// WEBPACK FOOTER //
// ./src/components/Emoji.jsx